import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';

export function Drawer(props, blocks = [], childrenComponents = []) {
	return {
		componentName: 'Drawer',
		componentId: uuidv4(),
		props: _.merge(
			{
				slideDirection: 'horizontal',
			},
			props,
		),
		blocks,
		childrenComponents,
	};
}
// {
//     componentName: 'Drawer',
//     componentId: uuidv4(),
//     props: {
//       blockClass: 'minha-classe',
//       slideDirection: 'horizontal',
//     },
//     blocks: [
//       {
//         componentName: 'DrawerHeader',
//         componentId: uuidv4(),
//         props: {
//           blockClass: 'drawer-class'
//         },
//         childrenComponents: [
//           {
//             componentName: "Logo",
//             componentId: uuidv4(),
//             props: {
//               width: 200,
//               height: 30,
//               mobileWidth: '',
//               mobileHeight: '',
//               url: "https://maeztra.com/wp-content/uploads/2020/09/logo_Prancheta-1.svg",
//               href: "/",
//               title: "Logo",
//               showLabel: true,
//               color: "#333333",
//             },
//             childrenComponents: [],
//           }
//         ],
//       }
//     ],
//     childrenComponents: [
//       {
//         componentName: 'Menu',
//         componentId: uuidv4(),
//         props: {
//           orientation: 'vertical',
//         },
//         childrenComponents: [
//           {
//             componentName: 'MenuItem',
//             componentId: uuidv4(),
//             props: {
//               id: 'menu-item-category-apparel-clothing',
//               type: 'custom',
//               iconId: null,
//               highlight: false,
//               itemProps: {
//                 type: 'internal',
//                 href: '/apparel---accessories/clothing/',
//                 noFollow: false,
//                 tagTitle: 'Clothing',
//                 text: 'Clothing',
//                 itemType: 'custom',
//               },
//             }
//           },
//           {
//             componentName: 'MenuItem',
//             componentId: uuidv4(),
//             props: {
//               id: 'menu-item-category-apparel-accessories',
//               type: 'custom',
//               iconId: null,
//               highlight: false,
//               itemProps: {
//                 type: 'internal',
//                 href: '/apparel---accessories/accessories/',
//                 noFollow: false,
//                 tagTitle: 'Accessories',
//                 text: 'Accessories',
//                 itemType: 'custom',
//               },
//             }
//           },
//           {
//             componentName: 'MenuItem',
//             componentId: uuidv4(),
//             props: {
//               id: 'menu-item-category-apparel-eyeglasses',
//               type: 'custom',
//               iconId: null,
//               highlight: false,
//               itemProps: {
//                 type: 'internal',
//                 href: '/apparel---accessories/eyeglasses/',
//                 noFollow: false,
//                 tagTitle: 'Eyeglasses',
//                 text: 'Eyeglasses',
//                 itemType: 'custom',
//               },
//             }
//           },
//         ],
//       }
//     ],
//   }
